export default __webpack_public_path__ + "static/media/filter-icon.a258985b.svg";